module.exports = __webpack_public_path__ + "static/media/kong.94db5d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/bindBank/index/images/kong.png
// module id = 1405
// module chunks = 0